export class TimeSheetHoursInfo {
  Id: number
  EmployeeCode: string
  TimeSheetCode: string
  TimeSheetDate: string
  ProjectCode: string
  Hours: number
  Date: string
  DayInWeek: string
  CreateDate: string
  CreateBy: string
  UpdateDate: string
  UpdateBy: string
  Detail: string

  TimesheetTypeCode:string
  TimesheetApplyTypeCode:string
  TimesheetDateStatus:string
}
